<template>
    <div id="first">
  <mcheader></mcheader>
      <div style="margin: auto;margin-top: 100px;width: 1048px;">
      <el-badge  class="item" v-for="(item2,index2) in orderstate" :key="index2" >
        <el-button type="primary" plain size="small" @click="showlist(item2.index)">{{item2.name}}</el-button>
      </el-badge>

      </div>
      <table class="td-void order-tb" style="margin: auto;margin-top: 30px;width: 1048px">
        <tbody id="tb-103588509139"  v-for="(item,index) in tableData" :key="index">
        <tr class="sep-row" style=" padding: 0;"></tr>
        <tr class="tr-th">
          <td colspan="5" style="height: 35px">
            <span class="gap"></span>
            <!--<span class="dealtime" title="2019-09-24 10:21:13">2019-09-24 10:21:13</span>-->
            <!--<input type="hidden" id="datasubmit-103588509139" value="2019-09-24 10:21:13">-->

            <span class="number" style="margin-left: 20px">订单号：<a name="orderIdLinks"  target="_blank"  clstag="click|keycount|orderinfo|order_num">{{item.order_info_id}}</a>
            </span>

            <div class="tr-operate">
              <span class="tel">
                            <i class="tel-icon venderTel667267" style="display: none;"></i>
                        </span>

              <a href="#none" clstag="click|keycount|orderlist|dingdanshanchu" class="order-del" _orderid="103588509139" _passkey="31B8A65B005937D9E6CEC17FA08E157E" title="删除" style="display: none;"></a>

            </div>
          </td>
        </tr>
        <tr class="tr-bd" id="track103588509139" oty="22,4,70" cxl="0" v-for="(item1,index1) in item.productList" :key="index1">
          <td >
            <div class="goods-item p-47989011215">
              <div class="p-img">
                <a clstag="click|keycount|orderinfo|order_product" target="_blank">
                  <img class="" :src="item1.product_img" data-lazy-img="done" style="width: 60px;height: 60px;" >

                </a>
              </div>
              <div class="p-msg">
                <div class="p-name"><div class="a-link" clstag="click|keycount|orderinfo|order_product" target="_blank" >{{item1.product_name}}({{item1.norm1}}{{item1.norm2}})</div></div>
              </div>
            </div>
            <div class="goods-number">
              x{{item1.product_count}}
            </div>

            <div class="goods-repair">
              <a  target="_blank" v-if="item1.after_sale_state == 0" style="cursor:pointer">
                申请售后
              </a>
              <a  target="_blank" v-if="item1.after_sale_state == 1">
                已申请售后
              </a>
            </div>
            <div class="clr"></div>
          </td>
          <td rowspan="1" >
            <div class="amount">
              <span>总额 ¥{{item1.pay_price}}</span> <br>
            </div>
          </td>
          <td rowspan="1">
            <div class="status">
              <span class="order-status ftx-03" v-if="item.orderState == 0">未完成</span>
              <span class="order-status ftx-03" v-if="item.orderState == 1">待发货</span>
              <span class="order-status ftx-03" v-if="item.orderState == 2">已发货</span>
              <span class="order-status ftx-03" v-if="item.orderState == 3">已确认</span>
              <span class="order-status ftx-03" v-if="item.orderState == 4">已关闭</span>
              <span class="order-status ftx-03" v-if="item.orderState == 5">退货中</span>
              <span class="order-status ftx-03" v-if="item.orderState == 6">已退款</span>
              <br>
            </div>
          </td>
          <td rowspan="1">
            <div class="status">
              <span class="order-status ftx-03" v-if="item1.is_comment == 0">未评论</span>
              <span class="order-status ftx-03" v-if="item1.is_comment == 1">已评论</span>
            </div>
          </td>
          <td rowspan="1" id="operate103588509139">
            <div class="operate"><a href="//baitiao.jd.com/v3/ious/list" class="a-baitiao">在线支付</a><br>

              <div id="pay-button-103588509139" _baina="0"></div>

            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <!--<el-table-->
        <!--:data="tableData"-->
        <!--border-->
        <!--style="width: 80%;margin: auto;margin-top: 100px" >-->
        <!--<el-table-column-->
          <!--prop="date"-->
          <!--label="日期"-->
          <!--width="180">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="order_info_id"-->
          <!--label="订单号"-->
          <!--width="180">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="chanping"-->
          <!--label="产品">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="name"-->
          <!--label="姓名">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="address"-->
          <!--label="金额">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="state"-->
          <!--label="状态">-->
        <!--</el-table-column>-->
      <!--</el-table>-->
      <mcfoot></mcfoot>
    </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'
export default {
  name: 'orderlist',
  components:
    {
      mcheader,
      mcfoot
    },
  data () {
    return {
      tableData: [],
      orderstate: [{
        name: '全部订单', index: -1
      },
      {
        name: '未完成', index: 0
      },
      {
        name: '待发货', index: 1
      },
      {
        name: '已发货', index: 2
      },
      {
        name: '已确认', index: 3
      },
      {
        name: '已关闭', index: 4
      },
      {
        name: '退款管理', index: 5
      }],
      state: -1
    }
  },
  methods: {
    getstate () {
      var userid = sessionStorage.getItem('userId')
      if (userid == null) {
        this.open()
      } else {
        https.fetchPost('mocalilie/api/order/queryByOrderState', {
          userId: userid,
          start_no: 1,
          size: 100,
          order_state: this.state
        }).then((res) => {
          console.log(res.data.data)
          this.tableData = res.data.data
        })
      }
    },
    showlist (index) {
      console.log(index)
      this.state = index
      this.getstate()
    },
    open () {
      this.$confirm('当前未登陆，请登陆你的账户', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        center: true
      }).then(() => {
        this.$router.push('/login')
      })
    }
  },
  created () {
    this.getstate()
  }
}
</script>

<style scoped>
  .order-tb tbody td {
    border: 1px solid #e5e5e5;
  }
  .order-tb .tr-bd td {
    padding: 14px 0;
  }
  .root61 .order-tb .goods-item {
    width: 340px;
    margin-right: 74px;
  }
  .order-tb .goods-item {
    display: inline-block;
    display: block;
    float: left;
    width: 455px;
    margin-right: 10px;
  }
  .order-tb .tr-bd {
    text-align: center;
    vertical-align: top;
  }
  .clear, .clr {
    display: block;
    overflow: hidden;
    clear: both;
    height: 0;
    line-height: 0;
    font-size: 0;
  }
  .order-tb .goods-item .p-img {
    float: left;
    width: 60px;
    height: 60px;
    border: 1px solid #efefef;
    margin: 0 14px;
    _display: inline;
  }
  a {
    color: #666;
    text-decoration: none;
  }
  .root61 .order-tb .goods-item .p-msg {
    width: 240px;
  }
  .order-tb .goods-item .p-msg {
    float: left;
    width: 160px;
  }
  .order-tb .goods-item .p-name {
    height: 36px;
    line-height: 18px;

    color: #333;
    text-align: left;
  }
  .order-tb .goods-item .p-name a {
    color: #333;
    *zoom: 1;
  }
  .order-tb .goods-item .p-extra {
    color: #aaa;
    text-align: left;
  }
  .root61 .order-tb .goods-number {
    width: 70px;
  }
  .order-tb .goods-number {
    float: left;
    width: 40px;
    text-align: left;
    color: #aaa;
    font-family: verdana;
  }
  .root61 .order-tb .goods-repair {
    width: 104px;
  }
  .order-tb .goods-repair {
    float: right;
    width: 84px;
    text-align: center;
  }
  table {
    font: 12px/150% tahoma,arial,Microsoft YaHei,Hiragino Sans GB,"\u5b8b\u4f53",sans-serif;
    -webkit-font-smoothing: antialiased;
    color: #666;
    background: #fff;
  }
  .root61 .order-tb .goods-item {
    width: 340px;
    margin-right: 74px;
  }
  .order-tb .sep-row {
    height: 20px;
    padding: 0;
  }
  .item {
    margin-top: 10px;
    margin-right:20px;
  }
</style>



// WEBPACK FOOTER //
// src/orderlist.vue